import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { camelCase, snakeCase } from 'change-case';
import isArray from 'lodash/isArray';
import isNumber from 'lodash/isNumber';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';

export type FormatError<T = any> = {
  data: T;
  status: number | undefined;
};

export const formatError = (res: AxiosResponse): FormatError => {
  // ネットワークエラー時にaxiosはレスポンスがundefinedになる
  return {
    data: res.data,
    status: res ? res.status : undefined,
  };
};

const reform = (obj: unknown, keyConverter: (k: string) => string): any => {
  if (isArray(obj)) {
    return obj.map((o) => reform(o, keyConverter));
  }
  if (isString(obj) || isNumber(obj)) {
    return obj;
  }
  if (obj === undefined || obj === null) {
    return null;
  }

  const newObj = {};

  if (isObject(obj)) {
    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      const newKey = keyConverter(key);

      if (value === undefined) {
        return;
      }

      newObj[newKey] = isObject(value) ? reform(value, keyConverter) : value;
    });
  }

  return newObj;
};

export const reformToCamel = <T>(obj: unknown): T => {
  return reform(obj, camelCase);
};

export const reformToSnake = <T>(obj: unknown): T => {
  return reform(obj, snakeCase);
};

export const reformResponse = (response: AxiosResponse): AxiosResponse => {
  const data = reform(response.data, camelCase);

  return { ...response, data };
};

export const reformFaildResponse = (error: AxiosError) => {
  const { response } = error;
  const data = response ? reform(response.data, camelCase) : {};

  return Promise.reject({
    ...error,
    response: {
      ...response,
      data,
    },
  });
};

export const reformRequest = (
  config: AxiosRequestConfig,
): AxiosRequestConfig => {
  // NOTICE: multipart/form-data で送信する場合はconfigを変換しない
  if (isMultipartFormData(config.headers)) {
    return config;
  }
  return { ...config, data: reformToSnake(config.data) };
};

const isMultipartFormData = (headers: AxiosRequestConfig['headers']) =>
  headers && headers['Content-Type'] === 'multipart/form-data';
